import { BReactComponent } from 'blocks-cloud/b-react-component';
import _ from 'Cloud/Application/_';
import app from 'Cloud/Application/app';
import config from 'Cloud/config';
import { isPublicUpload, sendPublicUploadRadar } from 'Cloud/ui/PublicUpload';
import { HIDE_ADS } from 'reactApp/appHelpers/configHelpers';
import { addSmsMessageListener } from 'reactApp/modules/smsSender/smsEventListener';
import { sendLinkBySmsRequest } from 'reactApp/modules/smsSender/smsSender.module';
import { isReactMobilePublic } from 'reactApp/sections/MobilePublicPage/isReactMobilePublic';
import { MobilePublicPage } from 'reactApp/sections/MobilePublicPage/MobilePublicPage';
import { store } from 'reactApp/store';
import { MobilePublicPromoBanner } from 'reactApp/ui/Mobile/MobilePublicPromoBanner/MobilePublicPromoBanner';
import { sendGa } from 'reactApp/utils/ga';

const IS_PHONE = config.get('PHONE_BROWSER');
const IS_PUBLIC = config.get('PUBLIC');
let IS_PUBLIC_FOLDER = config.get('PUBLIC_FOLDER');
let isInited = false;

export const Public = {
    isChoosedPublicFile() {
        return IS_PUBLIC && !IS_PUBLIC_FOLDER;
    },

    isChoosedPublicFolder() {
        return IS_PUBLIC && IS_PUBLIC_FOLDER;
    },

    isPublic() {
        return IS_PUBLIC;
    },

    setChoosedPublicFolder(newValue) {
        IS_PUBLIC_FOLDER = newValue;
    },

    getCanonicalPublicLink() {
        if (!this.isPublic()) {
            return '';
        }

        const item = app.current();

        if (!item) {
            return '';
        }

        const tree = _.tree(app.getStorage());

        if (!tree) {
            return '';
        }

        const ancestors = tree.ancestorsOrSelf(app.current());

        if (!Array.isArray(ancestors) || !ancestors.length) {
            return '';
        }

        let rootId = ancestors[0];

        if (rootId === '/') {
            rootId = ancestors[1];
        }

        if (rootId && rootId !== '/') {
            return rootId;
        }

        return '';
    },
};

export default () => {
    if (!isInited) {
        isInited = true;

        if (IS_PUBLIC) {
            addSmsMessageListener(
                window,
                (phone) => store.dispatch(sendLinkBySmsRequest({ phone, gaCategory: 'publicadv' })),
                'r.mradx.net'
            );
        }

        app.on('page:start', () => {
            if (IS_PUBLIC && IS_PHONE && !config.get('IS_AUTO_TEST_HIDE')) {
                const component = new BReactComponent({
                    ReactComponent: MobilePublicPromoBanner,
                    renderMode: 'append',
                });
                const domNode = document.querySelector('#mobile-public-promo');

                if (domNode) {
                    component.renderTo(domNode, {
                        props: {
                            bannerData: config.get('MOBILE_PUBLIC_BANNER'),
                        },
                    });
                }

                sendGa('mobpub', 'show', HIDE_ADS ? 'noads' : 'ads');
            }

            if (isReactMobilePublic) {
                const component = new BReactComponent({
                    ReactComponent: MobilePublicPage,
                    renderMode: 'append',
                });

                component.renderTo(document.querySelector('#public-folder-mobile'));

                if (isPublicUpload()) {
                    sendPublicUploadRadar();
                }
            }
        });

        // TODO: убрать везде app.isPublic etc
        Object.assign(app, {
            ...Public,
        });
    }
};
